import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import useTripCreation from "@/stores/new-trip/useNewTrip";

interface TripNameStepProps {
  getFlagImage: (countryName: string) => string;
}

const TripNameStep: React.FC<TripNameStepProps> = ({ getFlagImage }) => {
  const { tripName, setTripName, nextStep } = useTripCreation();
  const [value, setValue] = useState(tripName);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const handleNext = () => {
    setTripName(value);
    nextStep();
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleNext();
    }
  };

  return (
    <div className="flex flex-col items-center justify-center space-y-8">
      <h2 className="text-2xl font-semibold text-neutral-800">
        Give your trip a name
      </h2>
      <div className="relative w-full">
        <div className="relative group">
          <Input
            id="tripName"
            value={value}
            onChange={handleChange}
            onKeyDown={handleKeyPress}
            placeholder="Enter the name of your trip"
            className="w-full pr-10 rounded-2xl py-6 pl-6 text-center text-md bg-white shadow-sm border border-gray-200 transition-all duration-200 focus:shadow-md"
            autoComplete="off"
          />
          <Button
            onClick={handleNext}
            className="absolute top-1/2 -translate-y-1/2 right-3 px-3 flex items-center justify-center bg-transparent hover:bg-transparent group-hover:translate-x-1 transition-transform duration-200"
          >
            <ArrowRight className="h-5 w-5 text-indigo-600" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TripNameStep;
